import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/components/index'], resolve)
    },
    {
      path: '/zongshu',
      name: 'zongshu',
      component: resolve => require(['@/components/zongshu'], resolve)
    },
    {
      path: '/brand',
      name: 'brand',
      component: resolve => require(['@/components/brand'], resolve)
    },
    {
      path: '/registration',
      name: 'registration',
      component: resolve => require(['@/components/registration'], resolve)
    },
    {
      path: '/sector',
      name: 'sector',
      component: resolve => require(['@/components/sector'], resolve)
    },
    {
      path: '/company/:id',
      name: 'company',
      component: resolve => require(['@/components/company'], resolve)
    }, 
    {
      path: '/sources',
      name: 'sources',
      component: resolve => require(['@/components/sources'], resolve)
    }, {
      path: '/copyright',
      name: 'copyright',
      component: resolve => require(['@/components/copyright'], resolve)
    }, {
      path: '/organization',
      name: 'organization',
      component: resolve => require(['@/components/organization'], resolve)
    }, {
      path: '/contact',
      name: 'contact',
      component: resolve => require(['@/components/contact'], resolve)
    }, {
      path: '/video',
      name: 'video',
      component: resolve => require(['@/components/video'], resolve)
    },
    {
      path: '/download',
      name: 'download',
      component: resolve => require(['@/components/download'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js